import styled from "../../../styled/index";
import { shadeAlternate } from "../../..";
export const Tag = styled("span") `
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 600;
  background: ${({ theme, background }) => background || shadeAlternate(0.08, theme.colors.background)};
  color: ${({ theme, text }) => text || theme.colors.text};
  padding: 6px 8px;
  border-radius: 3px;
  line-height: 1;
`;
//# sourceMappingURL=index.js.map